import React from 'react'
import ThankYouPage from '../Thankyou/ThankyouPage'

function Thankyou() {
  return (
    <>
        <ThankYouPage />
    </>
  )
}

export default Thankyou
